export const ArticleCardSizes = Object.freeze({
  SM: 'sm',
  MD: 'md',
});
